<template>
  <div class="loader" :class="showLoading ? 'active' : ''">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      viewBox="0 0 98.466 107.356"
    >
      <g transform="translate(-433.543 -156.68)">
        <path
          d="M521.728,160.137a8.377,8.377,0,0,0-1.208-.865,4.807,4.807,0,0,0,1.005,3.02c.791,1.453,1.6,2.9,2.339,4.379.663,1.321,1.294,2.663,1.928,4a5.081,5.081,0,0,1,.474,3.955c-1.579-1.018-3.254-1.895-4.735-3.059-1.41-1.11-2.014-2.693-2.842-4.232-2.227-4.068-4.973-8.144-9.035-10.555a6.553,6.553,0,0,0,1.419,2.589c.838,1.1,1.71,2.176,2.507,3.307a17.8,17.8,0,0,1,2.933,6.431c-.217.261-1.238-.122-1.483-.186-2.133-.592-4.205-1.447-6.456-1.407a26.4,26.4,0,0,0,6.941,4.4,5.531,5.531,0,0,1,2.138,1.611c1.312,1.686,1.434,4.119,1.66,6.156a33.319,33.319,0,0,1-1.879,16.44c-.548-4.371-2.8-8.761-6.628-11.121a7.977,7.977,0,0,0,1.721,4.77c2.672,3.789,2.315,8.693.8,12.864-2.557,2.841-5.8,4.794-8.948,6.9a35.351,35.351,0,0,0-1.265-10.27c-.06-.2-.312-1.449-.56-1.452-.211,2.107-.087,4.217-.346,6.323a22.032,22.032,0,0,1-2.294,7.333c-.306-.628-.5-1.312-.783-1.95a6.183,6.183,0,0,0-3.8-3.219,23.3,23.3,0,0,1,3.292,7.123c-1.494,1.027-2.961,2.071-4.37,3.212a13.8,13.8,0,0,1-4.206,2.238l-14.446-.021c-3.127-1.086-5.581-3.386-8.253-5.233a23.15,23.15,0,0,1,3.332-7.318,6.2,6.2,0,0,0-3.778,3.178c-.3.649-.5,1.342-.8,1.99a22.034,22.034,0,0,1-2.3-7.333c-.26-2.106-.136-4.216-.346-6.323-.249,0-.5,1.254-.56,1.452a34.907,34.907,0,0,0-1.254,10.448c-3.918-2.532-8.09-4.942-10.779-8.882a13.544,13.544,0,0,1,.487-9.588c.635-1.3,1.7-2.321,2.114-3.727a13.2,13.2,0,0,0,.462-2.516,14.92,14.92,0,0,0-6.3,9.357c-2.117-6.306-1.859-13.211-.383-19.625.578-1.792,2.439-2.546,3.951-3.395q1.76-.988,3.511-1.992a9.455,9.455,0,0,0,2.883-2.05,7.52,7.52,0,0,0-2.581.385c-1.931.514-3.856,1.052-5.779,1.6a4.646,4.646,0,0,1,.167-1.1c.541-2.51,2.14-4.542,3.664-6.536a30.173,30.173,0,0,0,3.046-4.953l-1.113.614a29.409,29.409,0,0,0-7.779,9.654,16.321,16.321,0,0,1-1.979,3.477,13.634,13.634,0,0,1-2.812,2.289c-.486.322-.977.638-1.455.972-.365.255-.967.8-1.411.39-.882-.918.441-2.976.719-4.035a25.917,25.917,0,0,1,1.678-3.913,23.729,23.729,0,0,0,3.122-6.713C439,164.009,434.3,175.06,433.6,182.559c-1.245,16.735,16.973,25.553,28.119,34.648q1.454,1.118,2.9,2.245c1.042.838,3.69,2.081,2.113,3.627-.576.44-1.4.092-2.019-.036-3.639-.589-7.326-.945-10.972-1.487-1.6-.21-3.386-1.333-4.974-.627-1.541,1-.226,2.94.437,4.1a16.531,16.531,0,0,1,1.146,2.444,6.076,6.076,0,0,0,2.944,3.452c1.715.835,3.638.632,5.469.953,2.785.643,5.9,1.008,8.1,3q.182.83.4,1.654l-.32,2.527h.93a27.741,27.741,0,0,0,.356,6.794c1.382,3.456,4.528,4.6,6.364,7.376a10.008,10.008,0,0,0-2.2-4.346c-1.87-2.713-2.31-4.452-1.137-7.454,1.58,3.068,4.125,3.668,7.921,3.942a18.6,18.6,0,0,0-.183-3.241A17.266,17.266,0,0,1,475.4,241c-2.782-1.205-5.6-3.2-4.385-5.467l.453.058c-.16-.064-.273-.146-.3-.255.432.055-.863-.565-.988-.651.212-1.605-1.187-1.834-2.293-2.041l.033-.234c2.15.487,5.515,1.647,6.836,3.084a1.08,1.08,0,0,1,.26.493,5.48,5.48,0,0,0,1.342,1.881c.32.319.8.744,1.33,1.24,1.112,1.18,2.651,1.158,3.735-.71A35.989,35.989,0,0,0,479.255,246a11.427,11.427,0,0,1-.28,2.311c-.653,3.007-2.549,5.064-3.545,9.77h-.209a8.66,8.66,0,0,0,3.565,4.325,5.721,5.721,0,0,0,7.073.725c2.234-.8,4.469-2.423,4.61-5.052l-.327,0c-1.212-5.748-3.7-7.385-3.821-12.081a32.814,32.814,0,0,0-2.17-7.609c1.567,2.464,3.023,1.615,4.754-.227a6.3,6.3,0,0,0,1.562-1.962,2.191,2.191,0,0,1,.344-.711c1.034-1.283,4.825-2.655,6.837-3.088l.036.234c-1.108.207-2.5.436-2.289,2.041-.132.094-1.374.675-.992.652-.021.109-.136.191-.3.255l.454-.057c1.895,3.7-6.375,6.395-7.984,6.6a20.173,20.173,0,0,0-.179,3.241c3.631-.389,6.013-.487,7.916-3.942a6.435,6.435,0,0,1-.645,6.717c-1.043,1.663-2.251,2.768-2.688,5.06,0,0,.008,0,.01,0,1.84-2.764,4.969-3.906,6.348-7.352a29,29,0,0,0,.359-6.794h.836l-.3-2.339c1.446-3.183,5.235-4.144,8.359-4.763a10.767,10.767,0,0,1,3.271-.331c4.156-.152,5.383-3.273,6.623-6.649,1.559-2.982,2.869-4.9-1.791-3.892-4.959.682-9.916,1.528-14.872,2.148-.861.02-1.686-.8-1.188-1.659a3.1,3.1,0,0,1,.755-.759c2.28-2.013,4.661-3.905,7.118-5.7,9.027-6.666,19.588-12.881,24.372-23.512C534.45,180.545,529.013,168.47,521.728,160.137Zm-42.771,81.82c-.143-.617-.372-.946-.737-.952C478.548,241.38,479,242.018,478.957,241.957Zm7.658,0c-.043.064.743-.953.738-.952C486.983,241.011,486.754,241.342,486.615,241.957Zm-12.624-4.982-1.5-.188c-1.14,2.113,3.416,3.861,5,4.1C476.7,239.551,474.706,238.408,473.991,236.976Zm19.091-.188-1.5.188c-.716,1.433-2.7,2.575-3.5,3.914C489.667,240.648,494.222,238.9,493.082,236.787Zm-50.953-57.6a58.178,58.178,0,0,0-.477,8.4c.08,1.414.229,2.824.362,4.234.036.378.221,1.152-.043,1.492-.359.462-.96-.175-1.216-.452-4.1-4.353-3.559-12.329,1.6-15.615C442.355,177.246,442.166,178.758,442.13,179.183ZM463.341,228.7c-1.187.081-2.38.035-4.226.035-2.62.572-5.175-.1-6.426-2.671-.183-.376-.315-.765-.476-1.149-.132-.314-.394-.65-.015-.9.313-.2.708-.039,1.019.08q5.307,2.064,10.622,4.116c.171.066.367.164.367.219,0,.029,0,.3-.159.377C463.846,228.907,463.539,228.689,463.341,228.7Zm15.2,6.92c-2.778-2.185-5.483-4.5-9.02-5.207l-.155-1.219c3.991.157,6.653,3.179,9.429,5.958A1.812,1.812,0,0,0,478.542,235.62Zm4.248,28.11a5.574,5.574,0,0,1-3.432-1.239l3.429-1.618,3.426,1.618A5.648,5.648,0,0,1,482.79,263.73Zm4.466-10.028.69,1.6-5.16,4.393-5.163-4.393.689-1.6c1.679,0,2.812,2.2,4.474,2.276C484.447,255.9,485.579,253.7,487.256,253.7Zm7.976-23.288c-3.533.7-6.24,3.022-9.017,5.207a1.808,1.808,0,0,0-.255-.469c2.776-2.778,5.439-5.8,9.43-5.958Zm11.448-4.365q2.662-1.1,5.37-2.084a2.463,2.463,0,0,1,1.723-.07c-1.251,3.286-3.4,4.669-6.916,4h-3.911C503.81,226.514,505.4,226.582,506.68,226.049ZM524.593,193.2a2.4,2.4,0,0,1-.8.214,3.633,3.633,0,0,1-.131-1.845c.133-1.966.282-3.931.421-5.9-.208-2.754-.437-5.5-.493-8.258.655.618,1.369,1.207,1.962,1.886a7.786,7.786,0,0,1,1.568,3.151C528,185.972,527.61,190.786,524.593,193.2Z"
          transform="translate(0)"
          fill="#d60812"
        ></path>
      </g>
    </svg>
  </div>

  <nav>
    <img :src="require('@/assets/bk-logo-navbar.webp')" alt="" />
  </nav>

  <div class="modalview row justify-content-center" v-if="!showLoading">
    <div
      class="col-md-4"
      v-if="variants && show0 && variants[0] && variants[0].options"
    >
      <h6 class="m-3 mb-3 title">Pick your {{ variants[0].name }} options</h6>
      <div class="card">
        <div class="row">
          <div
            class="col-12 row"
            v-for="(qtd, id) in variants[0].options"
            :key="id"
          >
            <h6 class="m-3 mb-3 title">
              Pick your {{ variants[0].options[id].name }} options
            </h6>
            <div class="title">
              <p v-if="variants[0].options[0].values[selected0Array[id]]">
                {{ variants[0].options[0].name }}:
                {{ variants[0].options[0].values[selected0Array[id]].name }}
              </p>
            </div>
            <div class="col-6 mb-5">
              <img
                v-if="
                  variants[0].options[id].values[selected0Array[id]].images[0]
                "
                :src="
                  variants[0].options[id].values[selected0Array[id]].images[0]
                "
                class="img-fluid"
              />
              <img v-else :src="variants[0].image" class="img-fluid" />
            </div>
            <div class="col-6 mb-5">
              <div class="grid">
                <div
                  v-for="(item, index) in variants[0].options[id].values"
                  :key="index"
                  @click="item.in_stock ? (selected0Array[id] = index) : ''"
                  :class="index == selected0Array[id] ? 'selected' : ''"
                >
                  <div :class="'disabled'" v-if="!item.in_stock"></div>
                  <img :src="item.images[0]" v-if="item.images" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col-md-4"
      v-if="variants && show1 && variants[1] && variants[1].options"
    >
      <h6 class="m-3 mb-3 title">Pick your {{ variants[1].name }} options</h6>
      <div class="card">
        <div class="row">
          <div class="title">
            <p>
              {{ variants[1].options[0].name }}:
              {{ variants[1].options[0].values[selected1].name }}
            </p>
          </div>
          <div class="col-6 mb-5" v-if="variants[1]">
            <img
              v-if="variants[1].options[0].values[selected1].images[0]"
              :src="variants[1].options[0].values[selected1].images[0]"
              class="img-fluid"
            />
            <img v-else :src="variants[1].image" class="img-fluid" />
          </div>
          <div class="col-6 mb-5" v-if="variants[1]">
            <div
              class="grid"
              v-if="
                variants[1].options[1] &&
                variants[1].options[1].name.includes('Size')
              "
            >
              <div
                v-for="(item, index) in variants[1].options[0].values"
                :key="index"
                @click="selected1 = index"
                :class="index == selected1 ? 'selected' : ''"
              >
                <!--<div :class="'disabled'" v-if="!item.in_stock"></div>-->
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
            <div class="grid" v-else>
              <div
                v-for="(item, index) in variants[1].options[0].values"
                :key="index"
                @click="item.in_stock ? (selected1 = index) : ''"
                :class="index == selected1 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
          </div>
          <div
            class="col-6"
            v-if="variants[1].options && variants[1].options[1]"
          >
            <img
              v-if="variants[1].options[1].values[selected1_1].images[0]"
              :src="variants[1].options[1].values[selected1_1].images[0]"
              class="img-fluid"
            />
            <img v-else :src="variants[1].image" class="img-fluid" />
          </div>
          <div
            class="col-6"
            v-if="
              variants[1].options[1] &&
              !variants[1].options[1].name.includes('Size')
            "
          >
            <div class="grid">
              <div
                v-for="(item, index) in variants[1].options[1].values"
                :key="index"
                @click="item.in_stock ? (selected1_1 = index) : ''"
                :class="index == selected1_1 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
          </div>
          <div
            class="col-6"
            v-if="
              variants[1].options[1] &&
              variants[1].options[1].name.includes('Size')
            "
          >
            <p>
              {{ variants[1].options[1].name }}:
              {{ variants[1].options[1].values[selected1_1].name }}
            </p>
            <div class="grid">
              <div
                v-for="(item, index) in possiveis1"
                :key="index"
                @click="item.in_stock ? (selected1_1 = index) : ''"
                :class="index == selected1_1 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                {{ tratar(item.name) }}
                {{ item[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="col-md-4"
      v-if="variants && show2 && variants[2] && variants[2].options"
    >
      <h6 class="m-3 mb-3 title">Pick your {{ variants[2].name }} options</h6>
      <div class="card">
        <div class="row">
          <div class="title">
            <p>
              {{ variants[2].options[0].name }}:
              {{ variants[2].options[0].values[selected2].name }}
            </p>
          </div>
          <div class="col-6 mb-5" v-if="variants[2]">
            <img
              v-if="variants[2].options[0].values[selected2].images[0]"
              :src="variants[2].options[0].values[selected2].images[0]"
              class="img-fluid"
            />
            <img v-else :src="variants[2].image" class="img-fluid" />
          </div>
          <div class="col-6 mb-5" v-if="variants[2]">
            <div
              class="grid"
              v-if="
                variants[2].options[1] && variants[2].options[1].name == 'Size'
              "
            >
              <div
                v-for="(item, index) in variants[2].options[0].values"
                :key="index"
                @click="selected2 = index"
                :class="index == selected2 ? 'selected' : ''"
              >
                <!--<div :class="'disabled'" v-if="!item.in_stock"></div>-->
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
            <div class="grid" v-else>
              <div
                v-for="(item, index) in variants[2].options[0].values"
                :key="index"
                @click="item.in_stock ? (selected2 = index) : ''"
                :class="index == selected2 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
          </div>
          <div
            class="col-6"
            v-if="variants[2].options && variants[2].options[1]"
          >
            <img
              v-if="variants[2].options[1].values[selected2_1].images[0]"
              :src="variants[2].options[1].values[selected2_1].images[0]"
              class="img-fluid"
            />
            <img v-else :src="variants[2].image" class="img-fluid" />
          </div>
          <div
            class="col-6"
            v-if="
              variants[2].options[1] &&
              !variants[2].options[1].name.includes('Size')
            "
          >
            <div class="grid">
              <div
                v-for="(item, index) in variants[2].options[1].values"
                :key="index"
                @click="item.in_stock ? (selected2_1 = index) : ''"
                :class="index == selected2_1 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                <img :src="item.images[0]" v-if="item.images" />
                {{ item[0] }}
              </div>
            </div>
          </div>
          <div
            class="col-6"
            v-if="
              variants[2].options[1] &&
              variants[2].options[1].name.includes('Size')
            "
          >
            <p>
              {{ variants[2].options[1].name }}:
              {{ variants[2].options[1].values[selected2_1].name }}
            </p>
            <div class="grid">
              <div
                v-for="(item, index) in possiveis2"
                :key="index"
                @click="item.in_stock ? (selected2_1 = index) : ''"
                :class="index == selected2_1 ? 'selected' : ''"
              >
                <div :class="'disabled'" v-if="!item.in_stock"></div>
                {{ tratar(item.name) }}
                {{ item[0] }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center">
    <button type="button" @click="checkout" class="btn btn-claim">
      CLAIM YOURS!
    </button>
  </div>
</template>

<script>
import axios from "axios";
const { entries, map } = require("lodash");
// @ is an alias to /src
export default {
  layout: "default",
  name: "ModalView",
  components: {},

  data() {
    return {
      variants: [],
      product0: null,
      variant0: null,
      variant0ID: null,
      product1: null,
      variant1: null,
      variant1ID: null,
      product2: null,
      variant2: null,
      variant2ID: null,
      product3: null,
      variant3: null,
      variant3ID: null,
      product4: null,
      variant4: null,
      variant4ID: null,
      show0: false,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      selected0: 0,
      selected1: 0,
      selected2: 0,
      selected3: 0,
      selected4: 0,
      selected0_1: 0,
      selected1_1: 0,
      selected2_1: 0,
      selected0Array: [],
      cupom: "",
      id: "",
      price: 0,
      to: "",
      showLoading: false,
      first_page: "",
      step: "0",
      subid_1: "",
      source: "",
      version: "modal",
      country: "",
    };
  },

  computed: {
    possiveis() {
      let possiveis = this.variants[0].options[1].values.filter((item) => {
        const result = map(entries(this.variants[0].stock), ([key, value]) => {
          const array = JSON.parse(key);
          if (value > 0)
            return { options: array[0] + "_" + array[1] + "_" + value };
        });
        if (
          JSON.stringify(result).includes(
            this.variants[0].options[0].values[this.selected0].id +
              "_" +
              item.id
          ) ||
          JSON.stringify(result).includes(
            item.id +
              "_" +
              this.variants[0].options[0].values[this.selected0].id
          )
        ) {
          item.in_stock = true;
          return item;
        } else {
          item.in_stock = false;
          return item;
        }
      });
      this.checkStok();
      return possiveis;
    },
    possiveis1() {
      let possiveis1 = this.variants[1].options[1].values.filter((item) => {
        const result = map(entries(this.variants[1].stock), ([key, value]) => {
          const array = JSON.parse(key);
          if (value > 0)
            return { options: array[0] + "_" + array[1] + "_" + value };
        });
        if (
          JSON.stringify(result).includes(
            this.variants[1].options[0].values[this.selected1].id +
              "_" +
              item.id
          ) ||
          JSON.stringify(result).includes(
            item.id +
              "_" +
              this.variants[1].options[0].values[this.selected1].id
          )
        ) {
          item.in_stock = true;
          return item;
        } else {
          item.in_stock = false;
          return item;
        }
      });
      this.checkStok1();
      return possiveis1;
    },
    possiveis2() {
      try {
        let possiveis2 = this.variants[2].options[1].values.filter((item) => {
          const result = map(
            entries(this.variants[2].stock),
            ([key, value]) => {
              const array = JSON.parse(key);
              if (value > 0)
                return { options: array[0] + "_" + array[1] + "_" + value };
            }
          );
          if (
            JSON.stringify(result).includes(
              this.variants[2].options[0].values[this.selected2].id +
                "_" +
                item.id
            ) ||
            JSON.stringify(result).includes(
              item.id +
                "_" +
                this.variants[2].options[0].values[this.selected2].id
            )
          ) {
            item.in_stock = true;
            return item;
          } else {
            item.in_stock = false;
            return item;
          }
        });
        this.checkStok2();
        return possiveis2;
      } catch (err) {
        return this.variants[2].options[1];
      }
    },
  },

  methods: {
    tratar(palavra) {
      if (palavra) {
        if (palavra.includes(" ")) return palavra.split(" ")[0];
        else return palavra;
      }
    },

    checkStok() {
      console.log(this.variants[0].options[1].values.length);
      for (var a = this.variants[0].options[1].values.length - 1; a > -1; a--) {
        console.log(this.variants[0].options[1].values[a]);
        if (this.variants[0].options[1].values[a].in_stock) {
          this.selected0_1 = a;
        }
      }
    },
    checkStok1() {
      console.log(this.variants[1].options[1].values.length);
      for (var a = this.variants[1].options[1].values.length - 1; a > -1; a--) {
        if (this.variants[1].options[1].values[a].in_stock) {
          this.selected1_1 = a;
        }
      }
    },
    checkStok2() {
      console.log(this.variants[2].options[1].values.length);
      for (var a = this.variants[2].options[1].values.length - 1; a > -1; a--) {
        if (this.variants[2].options[1].values[a].in_stock) {
          this.selected2_1 = a;
        }
      }
    },

    selectProduct(productArray, key) {
      this[productArray].forEach((product) => {
        product.selected = false;
      });
      this[productArray][key].selected = true;
    },

    async fetchVariantsList(id, key) {
      this.loading = !this.loading;
      try {
        let url = `https://ar5vgv5qw5.execute-api.us-east-1.amazonaws.com/list/${id}`;
        //https://h03ygoadc1      //ar5vgv5qw5
        if (this.country) url = url + "?country=" + this.country;
        let { data } = await axios.get(url);
        if (data.product.options.length > 0) this.variants[key] = data.product;
        else this.variants[key] = { options: null }; //[{ values: [] }]
        this.loading = !this.loading;
      } catch (error) {
        this.loading = !this.loading;
        console.log(error);
      }
    },

    async checkout() {
      this.loading = !this.loading;
      try {
        var body = { order_uuid: this.id, items: [] };
        if (this.country) {
          body.country = this.country;
        }
        let price0 = 0;
        if (this.product0 && this.variants[0].options) {
          if (this.show0) {
            price0 = parseFloat(this.variants[0].price.match(/\d+\.\d+/)[0]);
            const opt = new Object();
            for (
              var contA = 0;
              contA < this.variants[0].options.length;
              contA++
            ) {
              price0 =
                price0 +
                parseFloat(
                  this.variants[0].options[contA].values[
                    this.selected0Array[contA]
                  ].price.match(/\d+\.\d+/)[0]
                );
              opt[this.variants[0].options[contA].id] =
                this.variants[0].options[contA].values[
                  this.selected0Array[contA]
                ].id;
              if (contA == this.variants[0].options.length - 1) {
                body.items.push({
                  product_id: this.product0,
                  price: price0,
                  country: this.country ? this.country : "us",
                  quantity: 1,
                  options: opt,
                });
              }
            }
          } else {
            body.items.push({
              product_id: this.product0,
              price: 9.99,
              country: this.country ? this.country : "us",
              quantity: 1,
              options: { [this.variant0ID]: this.variant0 },
            });
          }
        }

        let price1 = 0;

        if (this.product1) {
          if (this.show1) {
            price1 = parseFloat(this.variants[1].price.match(/\d+\.\d+/)[0]);
            if (this.variants[1].options[1]) {
              price1 =
                price1 +
                parseFloat(
                  this.variants[1].options[0].values[
                    this.selected1
                  ].price.match(/\d+\.\d+/)[0]
                ) +
                parseFloat(
                  this.variants[1].options[1].values[
                    this.selected1_1
                  ].price.match(/\d+\.\d+/)[0]
                );
              body.items.push({
                product_id: this.product1,
                price: price1,
                country: this.country ? this.country : "us",
                quantity: 1,
                options: {
                  [this.variants[1].options[0].id]:
                    this.variants[1].options[0].values[this.selected1].id,
                  [this.variants[1].options[1].id]:
                    this.variants[1].options[1].values[this.selected1_1].id,
                },
              });
            } else {
              price1 =
                price1 +
                parseFloat(
                  this.variants[1].options[0].values[
                    this.selected1
                  ].price.match(/\d+\.\d+/)[0]
                );
              body.items.push({
                product_id: this.product1,
                country: this.country ? this.country : "us",
                price: price1,
                quantity: 1,
                options: {
                  [this.variants[1].options[0].id]:
                    this.variants[1].options[0].values[this.selected1].id,
                },
              });
            }
          } else {
            body.items.push({
              product_id: this.product1,
              country: this.country ? this.country : "us",
              price: 9.99,
              quantity: 1,
              options: { [this.variant1ID]: this.variant1 },
            });
          }
        }
        let price2 = 0;
        if (this.product2) {
          if (this.show2) {
            price2 = parseFloat(this.variants[2].price.match(/\d+\.\d+/)[0]);
            if (this.variants[2].options[1]) {
              price2 =
                price2 +
                parseFloat(
                  this.variants[2].options[0].values[
                    this.selected2
                  ].price.match(/\d+\.\d+/)[0]
                ) +
                parseFloat(
                  this.variants[2].options[1].values[
                    this.selected2_1
                  ].price.match(/\d+\.\d+/)[0]
                );
              body.items.push({
                product_id: this.product2,
                country: this.country ? this.country : "us",
                price: price2,
                quantity: 1,
                options: {
                  [this.variants[2].options[0].id]:
                    this.variants[2].options[0].values[this.selected2].id,
                  [this.variants[2].options[1].id]:
                    this.variants[2].options[1].values[this.selected2_1].id,
                },
              });
            } else {
              price2 =
                price2 +
                parseFloat(
                  this.variants[2].options[0].values[
                    this.selected2
                  ].price.match(/\d+\.\d+/)[0]
                );
              body.items.push({
                product_id: this.product2,
                country: this.country ? this.country : "us",
                price: price2,
                quantity: 1,
                options: {
                  [this.variants[2].options[0].id]:
                    this.variants[2].options[0].values[this.selected2].id,
                },
              });
            }
          } else {
            body.items.push({
              product_id: this.product2,
              country: this.country ? this.country : "us",
              price: 9.99,
              quantity: 1,
              options: { [this.variant2ID]: this.variant2 },
            });
          }
        }

        /*if (this.product3 && this.show3)
          body.items.push({
            id: this.product3,
            quantity: 1,
            options: {
              [this.variant3ID]: this.variant3,
            },
          });*/

        this.showLoading = true;
        await axios.post(
          `https://ar5vgv5qw5.execute-api.us-east-1.amazonaws.com/upsell/${this.id}`,
          body
        );
        //console.log(`https://ecommerce.bckd.co/cart/add?${body}`)
        //window.location.href = `https://buckedup.com`;
        var precooo = 0;
        try {
          precooo = price1 + price0 + price2;
        } catch (err) {
          precooo = price0;
        }

        window.dataLayer.push({
          step_count: "modal", //modal
          page_id: this.from, //{{page_id, página anterior}}
          version_id: this.version, //v2-modal
          event: "interaction", //offer_view, interaction, pageview
          action: "purchase-us", //purchase, purchase-us,click, view_page
          value: precooo, //final purchase value
          transaction_id: this.id, //id
          country: this.country ? this.country : "us",
          currency: this.country
            ? this.variants[0].options[0].values[this.selected0].price.substr(
                0,
                3
              )
            : "",
        });

        if (this.to) {
          if (this.source) {
            if (this.source === "smartlink")
              window.location.href = `https://bckd.co/${this.to}${this.subid_1}`;
            if (this.source === "instapage")
              window.location.href = `https://get.buckedup.com/${this.to}${this.subid_1}`;
          } else
            window.location.href = `https://offers.buckedup.com/${this.to}${this.subid_1}`;
        } else {
          await axios.post(
            `https://ar5vgv5qw5.execute-api.us-east-1.amazonaws.com/upsell/${this.id}/finish`
          );

          if(this.country)
          window.location.href = `https://${this.country}.buckedup.com/extension/misc/upsell/complete${this.subid_1}`;
          else
          window.location.href = `https://www.buckedup.com/extension/misc/upsell/complete${this.subid_1}`;
        }
      } catch (error) {
        this.showLoading = false;
        console.log(error);
      }
    },

    async getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          console.log("Log", c.substring(name.length, c.length));
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },

  async mounted() {
    const params = new URLSearchParams(window.location.search);

    const queryString = window.location.search;
    this.subid_1 = queryString;

    if (params.get("country")) this.country = params.get("country");

    this.id = params.get("order_uuid");
    this.to = params.get("to");
    this.source = params.get("source");
    this.from = params.get("from");
    if (await this.getCookie("offer_id")) {
      this.version = await this.getCookie("offer_id");
    }
    if (await this.getCookie("page_id")) {
      this.from = await this.getCookie("page_id");
    }
    this.step = params.get("step");

    this.first_page = localStorage.getItem("first_page");
    var _this = this;
    if (params.has("product0")) {
      this.product0 = params.get("product0");
      this.subid_1 = this.subid_1.replace(`product0=${this.product0}`, "");
      this.variant0 = params.get("variant0");
      this.variant0ID = params.get("variant0ID");

      window.dataLayer.push({
        step_count: "modal", //modal
        page_id: this.from, //{{page_id, página anterior}}
        version_id: this.version, //v2-modal
        event: "offerview", //offer_view, interaction, pageview
        action: "offerview", //purchase, purchase-us,click, view_page
        transaction_id: this.id, //id
        country: this.country ? this.country : "us",
      });

      if (
        this.variant0ID === "undefined" ||
        !params.has("variant0ID") ||
        this.variant0ID === "0" ||
        this.variant0ID === "n"
      ) {
        this.show0 = true;
      }
      await this.fetchVariantsList(this.product0, 0);
      if (this.variants[0].options) {
        if (Object.keys(this.variants[0].stock)[0].includes(",")) {
          this.regraEstoque = true;
        } else {
          if (
            this.variants[0].options[0] &&
            !this.variants[0].options[0].values[0].in_stock
          ) {
            _this.selected0 = _this.selected0 + 1;
            for (
              var a = 1;
              a < this.variants[0].options[0].values.length;
              a++
            ) {
              if (!this.variants[0].options[0].values[a].in_stock) {
                _this.selected0 = _this.selected0 + 1;
              } else a = 99;
            }
          }
          if (
            this.variants[0].options[1] &&
            !this.variants[0].options[1].values[0].in_stock
          ) {
            _this.selected0_1 = _this.selected0_1 + 1;
            for (a = 1; a < this.variants[0].options[1].values.length; a++) {
              if (!this.variants[0].options[1].values[a].in_stock) {
                _this.selected0_1 = _this.selected0_1 + 1;
              } else a = 99;
            }
          }
        }
      }
      this.variants[0].options.map(function () {
        return _this.selected0Array.push(0);
      });
    }
    if (params.has("product1")) {
      this.product1 = params.get("product1");
      this.subid_1 = this.subid_1.replace(`product1=${this.product1}`, "");
      this.variant1 = params.get("variant1");
      this.variant1ID = params.get("variant1ID");
      if (
        this.variant1ID === "undefined" ||
        !params.has("variant1ID") ||
        this.variant1ID === "0" ||
        this.variant1ID === "n"
      ) {
        this.show1 = true;
      }
      await this.fetchVariantsList(this.product1, 1);
    }
    if (params.has("product2")) {
      this.product2 = params.get("product2");
      this.variant2 = params.get("variant2");
      this.variant2ID = params.get("variant2ID");
      if (
        this.variant2ID === "undefined" ||
        !params.has("variant2ID") ||
        this.variant2ID === "0" ||
        this.variant2ID === "n"
      ) {
        this.show2 = true;
      }
      await this.fetchVariantsList(this.product2, 2);
    }
    if (params.has("product3")) {
      this.product3 = params.get("product3");
      this.variant3 = params.get("variant3");
      this.variant3ID = params.get("variant3ID");
      if (this.variant3ID === "undefined" || !params.has("variant3ID")) {
        this.show3 = true;
      }
      await this.fetchVariantsList(this.product3, 3);
    }
    if (params.has("product4")) {
      this.product4 = params.get("product4");
      this.variant4 = params.get("variant4");
      this.variant4ID = params.get("variant4ID");
      if (this.variant4ID === "undefined" || !params.has("variant4ID")) {
        this.show4 = true;
      }
      await this.fetchVariantsList(this.product4, 4);
    }
    if (params.has("discount")) {
      this.cupom = params.get("discount");
    }

    setTimeout(() => {
      if (
        !this.show4 &&
        !this.show0 &&
        !this.show1 &&
        !this.show2 &&
        !this.show3
      ) {
        this.checkout();
      }
    }, "2 second");
  },
};
</script>

<style lang="scss">
.card {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 30px;
  margin-top: 16px;
  padding: 1.5rem 1.5rem;
  border-color: #fff;
  min-height: 40vh;
  //justify-content: center;
}

.conteudo:last-child {
  border: 10px dashed blue;
}

.mb-5 {
  margin-bottom: 1px !important;
}

.grid {
  display: flex;
  //max-width: 200px;
  flex-wrap: wrap;
  margin-top: 15px;

  div {
    border: 1px solid transparent;
    border-radius: 50%;
    padding: 5px;
    margin: 0.5rem 0.5rem 0 0;
    position: relative;
    cursor: pointer;

    &.selected {
      border-color: #01ff85;

      &:before {
        content: "✓";
        border-radius: 50%;
        text-align: center;
        line-height: 1.5;
        font-size: 0.8rem;
        width: 20px;
        height: 20px;
        font-weight: bold;
        position: absolute;
        background: #01ff85;
        color: #000;
        top: -8%;
        left: -8%;
      }
    }

    img {
      max-width: 50px;
      border-radius: 50%;

      @media (max-width: 376px) {
        max-width: 35px;
      }
    }
  }
}

.title {
  text-align-last: center;
  text-align: center;
}

.disabled {
  background-color: dimgrey;
  color: linen;
  opacity: 0.8;
  width: 100%;
  position: absolute !important;
  top: -8px;
  left: 0px;
  z-index: 3;
  height: 47px;
}

.btn-claim {
  margin-top: 2rem;
  padding: 1.25rem 4.5rem;
  background: #25bfff;
  border-radius: 100px;
  color: #28125d;
  font-weight: bold;
  margin-bottom: 15px;
}

h6 {
  font-weight: bolder;
  color: #28125d;
}

.loader {
  width: 100vw;
  height: 100vh;

  background: rgba($color: #ffffff, $alpha: 1);

  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  display: flex;
  align-self: center;
  justify-content: center;

  pointer-events: none;
  opacity: 0;

  &.active {
    pointer-events: auto;
    opacity: 1;
  }

  svg {
    animation: scaleUp 3s ease-in-out infinite alternate;
  }
}

@keyframes scaleUp {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.5);
  }
}

.modalview {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;

  @media (max-width: 426px) {
    margin-top: 20px;
  }
}
</style>
